import { render, staticRenderFns } from "./wangEditQu.vue?vue&type=template&id=b9d1e05a&scoped=true"
import script from "./wangEditQu.vue?vue&type=script&lang=js"
export * from "./wangEditQu.vue?vue&type=script&lang=js"
import style0 from "./wangEditQu.vue?vue&type=style&index=0&id=b9d1e05a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d1e05a",
  null
  
)

export default component.exports